
    import { Component, Mixins } from 'vue-property-decorator';
    import ProductCard from '@rogues/ProductCard/shared/productCard';
    import { YChips } from '@components/index';
    import { percent } from '@nodes/helpers/number';

    @Component({
        components: {
            YChips,
        },
    })
    /**
     * @name Minimal
     */
    export default class Minimal extends Mixins(ProductCard) {
        percent = percent;
        /**
         * Return badge products
         *
         * @returns {Array}
         */
        get productStatus() {
            const result: Array<{[k: string]: any}> = [];

            const badgeData: {[k: string]: any} = {
                color: 'warning',
                sharp: true,
                icon : {
                    library: 'material-icons',
                    size   : 'small',
                    color  : 'black',
                },
            };

            const listStatus: {[k: string]: any} = {
                new: {
                    text    : this.$t('productCard.new_product'),
                    iconName: 'star_border',
                },
                discount: {
                    text    : this.digits(this.percent(this.getValue('ware_original_price'), this.getValue('ware_sale_price')), this.$i18n.locale),
                    iconName: 'percent',
                },
            };

            if (this.isNewProduct) {
                result.push({
                    ...badgeData,
                    ...listStatus.new,
                });
            }

            if (this.hasDiscount) {
                result.push({
                    ...badgeData,
                    ...listStatus.discount,
                });
            }

            return result;
        }
    }
